export default __webpack_public_path__ + "static/media/6.b8f6d553.webp";